export default {
  "首页": "Trang Chủ",
  "订单": "Đơn Hàng",
  "新闻": "Tin Tức",
  "个人中心": "Trung Tâm Cá Nhân",
  "模拟账户": "Tài Khoản Mô Phỏng",
  "可用资产": "Tài Sản Sử Dụng Được",
  "入金": "Nạp Tiền",
  "出金": "Rút Tiền",
  "账单详情": "Chi Tiết Hóa Đơn",
  "重置模拟账户": "Đặt Lại Tài Khoản Mô Phỏng",
  "钱包": "Ví",
  "实名认证": "Xác Thực Danh Tính",
  "邀请好友": "Mời Bạn Bè",
  "修改密码": "Thay Đổi Mật Khẩu",
  "投诉邮箱": "Email Khiếu Nại",
  "其它": "Khác",
  "公告": "Thông Báo",
  "语言": "Ngôn Ngữ",
  "是否退出登录": "Bạn có chắc chắn muốn đăng xuất?",
  "复制": "Sao Chép",
  "复制成功": "Sao Chép Thành Công",
  "发送验证码成功": "Gửi Mã Xác Thực Thành Công",
  "请输入密码": "Vui lòng nhập mật khẩu",
  "请再次输入密码": "Vui lòng nhập lại mật khẩu",
  "复制邀请链接": "Sao Chép Liên Kết Mời",
  "上传身份": "Vui lòng tải lên mặt trước và mặt sau của hộ chiếu/CMND",
  "正面": "Mặt Trước",
  "上传正面": "Tải lên mặt trước hộ chiếu/CMND",
  "反面": "Mặt Sau",
  "上传反面": "Tải lên mặt sau hộ chiếu/CMND",
  "完善信息": "Vui lòng hoàn thiện thông tin cá nhân",
  "输入姓名": "Vui lòng nhập tên của bạn",
  "身份证号": "Số hộ chiếu/CMND",
  "输入身份证号": "Vui lòng nhập số hộ chiếu/CMND của bạn",
  "收款货币": "Tiền Tệ Nhận",
  "银行名称": "Tên Ngân Hàng",
  "收款人账户": "Tài Khoản Người Nhận",
  "货币": "Tiền Tệ",
  "分店名称": "Tên Chi Nhánh",
  "绑定银行卡": "Liên Kết Thẻ Ngân Hàng",
  "银行地址": "Địa Chỉ Ngân Hàng",
  "账号名称（假名）": "Tên Tài Khoản (Tên Giả)",
  "绑定数字货币地址": "Liên Kết Địa Chỉ Tiền Điện Tử",
  "余额": "Số Dư",
  "联系客服": "Liên Hệ Hỗ Trợ Khách Hàng",
  "行情": "Thị Trường",
  "其他": "Khác",
  "设置": "Cài Đặt",
  "收款人": "Người Nhận",
  "添加": "Thêm",
  "确认": "Xác Nhận",
  "取消": "Hủy",
  "钱包地址": "Địa Chỉ Ví",
  "请输入": "Vui lòng nhập",
  "退出登录": "Đăng Xuất",
  "充值数量": "Số Tiền Nạp",
  "提交": "Gửi",
  "银行卡": "Thẻ Ngân Hàng",
  "选择网络": "Chọn Mạng",
  "数字货币": "Tiền Điện Tử",
  "上传验证": "Tải Lên Xác Thực",
  "提币地址": "Địa Chỉ Rút Tiền",
  "数量(USD)": "Số Lượng (USD)",
  "备注": "Ghi Chú",
  "手续费": "Phí Giao Dịch",
  "预计到账数量": "Số Tiền Dự Kiến Nhận Được",
  "暂无数据": "Chưa có dữ liệu",
  "入金记录": "Lịch Sử Nạp Tiền",
  "提币记录": "Lịch Sử Rút Tiền",
  "验证码": "Mã Xác Thực",
  "邀请码": "Mã Mời",
  "提示": "Lưu Ý",
  "请输入验证码": "Vui lòng nhập mã xác thực",
  "姓名": "Tên",
  "邮箱登录": "Đăng Nhập Qua Email",
  "邮箱": "Email",
  "密码": "Mật Khẩu",
  "新用户": "Người Dùng Mới",
  "立即加入": "Tham Gia Ngay",
  "忘记密码": "Quên Mật Khẩu",
  "登录": "Đăng Nhập",
  "无需开户,立即创建模拟账号进行交易!": "Không cần mở tài khoản, tạo tài khoản mô phỏng ngay để giao dịch!",
  "电话": "Điện Thoại",
  "再次输入密码": "Nhập lại mật khẩu",
  "职业": "Nghề Nghiệp",
  "年收入": "Thu Nhập Hàng Năm",
  "注册": "Đăng Ký",
  "邮箱注册": "Đăng Ký Email",
  "发送": "Gửi",
  "重置密码": "Đặt Lại Mật Khẩu",
  "是否重置": "Bạn có chắc chắn muốn đặt lại mật khẩu?",
  "已重置": "Đã Đặt Lại",
  "名称": "Tên",
  "注册成功": "Đăng Ký Thành Công",
  "加载中": "Đang Tải",
  "您还未登录，请先登录": "Bạn chưa đăng nhập, vui lòng đăng nhập trước",
  "退出成功": "Đăng Xuất Thành Công",
  "市价": "Giá Thị Trường",
  "挂单": "Đặt Lệnh",
  "倍数": "Số Lần",
  "止盈": "Chốt Lãi",
  "止损": "Cắt Lỗ",
  "买入数量": "Số Lượng Mua",
  "每手": "Mỗi Lệnh",
  "预估手续费": "Phí Giao Dịch Dự Kiến",
  "预估保证金": "Ký Quỹ Dự Kiến",
  "买入": "Mua",
  "卖出": "Bán",
  "您的订单已确认": "Đơn Hàng Của Bạn Đã Được Xác Nhận",
  "订单页面": "Trang Đơn Hàng",
  "盈亏": "Lãi Lỗ",
  "当前保证金": "Ký Quỹ Hiện Tại",
  "订单详情": "Chi Tiết Đơn Hàng",
  "保证金": "Ký Quỹ",
  "平仓": "Đóng Lệnh",
  "修改": "Sửa",
  "手数": "Số Lệnh",
  "暂无数据": "Chưa Có Dữ Liệu",
  "历史": "Lịch Sử",
  "价格": "Giá",
  "请输入价格": "Vui lòng nhập giá",
  "手": "Lệnh",
  "搜索结果": "Kết Quả Tìm Kiếm",
  "搜索产品": "Tìm Sản Phẩm",
  "持仓": "Vị Thế",
  "语言": "Ngôn Ngữ",
  "审核中": "Đang Xem Xét",
  "请上传证件照正/反面": "Vui lòng tải lên mặt trước và mặt sau của chứng minh thư",
  "上传成功": "Tải Lên Thành Công",
  "上传失败": "Tải Lên Thất Bại",
  "提交成功": "Gửi Thành Công",
  "删除": "Xóa",
  "删除成功": "Xóa Thành Công",
  "提币": "Rút Tiền Điện Tử",
  "缺少参数或传值错误": "Thiếu Tham Số Hoặc Lỗi Truyền Giá Trị",
  "操作成功": "Thao Tác Thành Công",
  "充值金额": "Số Tiền Nạp",
  "类型": "Loại",
  "状态": "Trạng Thái",
  "时间": "Thời Gian",
  "单位": "Đơn Vị",
  "最高价": "Giá Cao Nhất",
  "最低价": "Giá Thấp Nhất",
  "开盘价": "Giá Mở Cửa",
  "请注册或登录真实账号": "Vui lòng đăng ký hoặc đăng nhập vào tài khoản thật",
  "没有更多了": "Không Còn Dữ Liệu",
  "提现金额": "Số Tiền Rút",
  "审核通过": "Duyệt Thành Công",
  "审核不通过": "Duyệt Thất Bại",
  "重新提交": "Gửi Lại",
  "止盈价": "Giá Chốt Lãi",
  "止损价": "Giá Cắt Lỗ",
  "总盈亏": "Tổng Lãi Lỗ",
  "撤单": "Hủy Lệnh",
  "成功": "Thành Công",
  "请先进行实名认证": "Vui lòng thực hiện xác thực danh tính trước",
  "下单余额不足": "Số Dư Không Đủ Để Đặt Lệnh",
  "客服": "Hỗ Trợ Khách Hàng",
  "卖出(做空)止损价不能低于开仓价": "Giá Cắt Lỗ Bán (Short) Không Thể Thấp Hơn Giá Mở Lệnh",
  "卖出(做多)止盈价不能高于开仓价": "Giá Chốt Lãi Bán (Long) Không Thể Cao Hơn Giá Mở Lệnh",
  "买入(做多)止损价不能高于开仓价": "Giá Cắt Lỗ Mua (Long) Không Thể Cao Hơn Giá Mở Lệnh",
  "买入(做多)止盈价不能低于开仓价": "Giá Chốt Lãi Mua (Long) Không Thể Thấp Hơn Giá Mở Lệnh",
  "买入(做多)止盈价不能低于开仓价和现价": "Giá Chốt Lãi Mua (Long) Không Thể Thấp Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "买入(做多)止损价不能高于开仓价和现价": "Giá Cắt Lỗ Mua (Long) Không Thể Cao Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "卖出(做空)止损价不能低于开仓价和现价": "Giá Cắt Lỗ Bán (Short) Không Thể Thấp Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "卖出(做多)止盈价不能高于开仓价和现价": "Giá Chốt Lãi Bán (Long) Không Thể Cao Hơn Giá Mở Lệnh và Giá Hiện Tại",
  "该币种暂无交易": "Loại tiền này hiện không có giao dịch",
  "期权": "Quyền chọn",
  "期权交易": "Giao dịch quyền chọn",
  "可用余额": "Số dư khả dụng",
  "交易周期": "Chu kỳ giao dịch",
  "买涨": "Mua lên",
  "买跌": "Mua xuống",
  "持有订单": "Đơn hàng đang giữ",
  "历史订单": "Lịch sử đơn hàng",
  "暂无订单": "Chưa có đơn hàng",
  "看涨": "Xu hướng tăng",
  "看跌": "Xu hướng giảm",
  "下单时间": "Thời gian đặt lệnh",
  "剩余时间": "Thời gian còn lại",
  "交易额": "Số tiền giao dịch",
  "秒": "giây",
  "买入价": "Giá mua",
  "结算价": "Giá thanh toán",
  "实现盈利": "Lợi nhuận thực tế",
  "结算时间": "Thời gian thanh toán",
  "订单号": "Mã đơn hàng",
  "输入交易额度": "Nhập số tiền giao dịch",
  "选择交易周期": "Chọn chu kỳ giao dịch",
  "是否购买？": "Bạn có muốn mua không?",
  "确定": "Xác nhận",
  "取消": "Hủy",
  "购买成功": "Mua thành công",
  "期权交易订单": "Lệnh giao dịch quyền chọn",
  "加载中": "Đang tải",
  "没有更多了": "Không còn gì nữa",
  "全部订单": "Tất cả đơn hàng",
  '从': 'Từ',
  '请输入数量': 'Vui lòng nhập số lượng',
  '全部': 'Tất cả',
  '可用余额': 'Số dư khả dụng',
  '到': 'Đến',
  '兑换': 'Đổi',
  '币种选择': 'Chọn loại tiền',
  '请输入正确的数量!': 'Vui lòng nhập số lượng chính xác!',
  '兑换成功!': 'Đổi thành công!',
  '发送验证码成功': 'Mã xác thực đã được gửi thành công',
  '请输入正确的邮箱地址!': 'Vui lòng nhập địa chỉ email hợp lệ!',
  '选填': 'Tùy chọn',
  '上述信息最终解释权归官方所有': 'Quyền giải thích cuối cùng của thông tin trên thuộc về cơ quan chức năng',
  '公司资质': 'Tư cách công ty',
  '白皮书': 'Sách trắng',
  '注册证书': 'Chứng nhận đăng ký',
  '闪兑历史': 'Lịch sử đổi nhanh',
  '加载中': 'Đang tải...',
  '没有更多了': 'Không còn nữa',
  '全部兑换成功': 'Tất cả các giao dịch đã thành công',
  '支付': 'Thanh toán',
  '获取': 'Nhận',
  '时间': 'Thời gian',
  '手续费': 'Phí giao dịch',
  '资产总折合': 'Tổng giá trị tài sản quy đổi',
  '总资产': 'Tổng tài sản',
  '幣種': 'Loại tiền',
  '余额': 'Số dư',
  '冻结金额': 'Số tiền bị khóa',
  '可用金额': 'Số tiền khả dụng',
  '资产折合': 'Giá trị tài sản',
  '闪电兑换': 'Đổi nhanh',
  '我的资产': 'Tài sản của tôi',
  "数量": "số lượng",
  '拒绝原因': 'Lý do từ chối',
  '交易密码': 'Mật khẩu giao dịch',
  '提示': 'Thông báo',
  '您还未设置交易密码,请先设置': 'Bạn chưa đặt mật khẩu giao dịch, vui lòng thiết lập trước',
  '修改交易密码': 'Đổi mật khẩu giao dịch',
  '设置交易密码': 'Thiết lập mật khẩu giao dịch',
  '点击发送按钮,我们将发送一条验证码至您注册时的邮箱,请注意查收!': 'Nhấn nút gửi, chúng tôi sẽ gửi mã xác nhận đến email đăng ký của bạn, vui lòng kiểm tra!',
  '两次密码不一致': 'Hai mật khẩu không khớp',
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Giao dịch của bạn đang được xử lý, vui lòng kiên nhẫn chờ giao dịch hoàn tất trước khi thực hiện các thao tác khác!",
  "继续下单": "Tiếp tục đơn hàng",
  "交易方向": "Hướng giao dịch",
  "实现盈利": "Thực hiện lợi nhuận",
  "最新价格": "Giá mới nhất",
  "结算完成": "Thanh toán hoàn tất",
  "最小提现金额10USDT": "Số tiền rút tối thiểu: 10 USDT",
  "下单余额不足": "Số dư không đủ để đặt hàng",
  "输入交易额度": "Nhập số tiền giao dịch",
  "选择交易周期": "Chọn chu kỳ giao dịch",
  "审核拒绝": "Duyệt bị từ chối",
  "请输入正确的数量!": "Vui lòng nhập số lượng chính xác!",
  "上传身份": "Tải lên chứng minh thư",
  "上传正面": "Tải lên mặt trước",
  "上传反面": "Tải lên mặt sau",
  "完善信息": "Hoàn thiện thông tin",
  "输入姓名": "Nhập tên",
  "输入身份证号": "Nhập số CMND",
  "身份证号": "Số CMND",
  "请上传证件照正/反面": "Vui lòng tải lên ảnh chứng minh thư mặt trước/sau",
  "最小提现金额10USDT": "Số tiền rút tối thiểu là 10 USDT",
  "证件号码": "Số chứng minh nhân dân",
  "输入证件号码": "Nhập số chứng minh nhân dân",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Vui lòng tải lên chứng minh nhân dân, giấy phép lái xe hoặc hộ chiếu để xác minh danh tính!"



}
